import React from 'react';

const DesktopLayout = ({ children, styles, onClose }) => {
    const [navigationButton, thoughtEditor, actionButtons] = children;

    return (
        <>
            <div 
                style={styles.composePage.desktop.overlay}
                onClick={onClose}
            />
            
            <div style={styles.composePage.desktop.container}>
                <div style={styles.composePage.desktop.header}>
                    {navigationButton}
                    <div style={styles.composePage.desktop.buttonContainer}>
                        {actionButtons}
                    </div>
                </div>
                
                <div style={styles.composePage.desktop.textareaContainer}>
                    {thoughtEditor}
                </div>

                <style>{`
                    div::-webkit-scrollbar {
                        display: none;
                    }
                `}</style>
            </div>
        </>
    );
};

export default DesktopLayout; 